import { useAuth } from "@babackapp/auth-client/hooks";
import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";

export type ProductReferencesVisibility = {
  /** References are on screen: logged-in merchant, or the shop shows them. */
  shouldShow: boolean;
  /**
   * Only the logged-in merchant sees them (setting off): the screens add the
   * "visible only to you" hint. False when customers see them too.
   */
  isMerchantOnly: boolean;
};

/**
 * Who sees product references (SKU) in the portal: always a logged-in
 * merchant, the customer only when the shop turns on
 * `exchange.shouldShowProductReferences` (one product per colour under the
 * same title, e.g. Repetto). Off by default.
 */
export function useProductReferencesVisibility(
  shopId: string,
): ProductReferencesVisibility {
  const { data: shop } = usePublicShop(shopId);
  const { isAuthenticated } = useAuth();
  const isShownToCustomers =
    shop?.exchange?.shouldShowProductReferences === true;
  return {
    shouldShow: isAuthenticated || isShownToCustomers,
    isMerchantOnly: isAuthenticated && !isShownToCustomers,
  };
}

/** `useProductReferencesVisibility(shopId).shouldShow`. */
export function useShowProductReferences(shopId: string): boolean {
  return useProductReferencesVisibility(shopId).shouldShow;
}
